module.exports = __webpack_public_path__ + "img/kefu2.0b2f5c5f.png";